import { Info, TriangleAlert } from "lucide-react";
import { cn } from "@/lib/utils";

// tone: 'info' | 'warning'
export const AlertBox = ({ tone = "info", title, text, children, className = "" }) => {
  const isWarning = tone === "warning";
  return (
    <div
      data-testid={`alert-${tone}`}
      className={cn(
        "flex gap-4 rounded-2xl border p-6 md:p-7",
        isWarning
          ? "border-roman-red/25 bg-roman-red/[0.06]"
          : "border-gold/30 bg-gold/[0.07]",
        className
      )}
    >
      <div
        className={cn(
          "mt-0.5 shrink-0",
          isWarning ? "text-roman-red" : "text-gold-dark"
        )}
      >
        {isWarning ? (
          <TriangleAlert size={22} strokeWidth={1.75} />
        ) : (
          <Info size={22} strokeWidth={1.75} />
        )}
      </div>
      <div>
        {title && (
          <h4 className="font-serif text-xl font-medium text-charcoal">{title}</h4>
        )}
        {text && (
          <p className="mt-1.5 text-base leading-relaxed font-light text-slatey">
            {text}
          </p>
        )}
        {children}
      </div>
    </div>
  );
};

export default AlertBox;
